module.exports = __webpack_public_path__ + "img/logo-bolder.96a73c9e.png";